/**
 * Light / dark / follow-the-system, persisted per browser.
 *
 * The tokens define both themes; this only decides which signal wins. `system`
 * removes the attribute so the `prefers-color-scheme` media query in tokens.css
 * takes over.
 */

export type ThemeChoice = 'system' | 'light' | 'dark'

const STORAGE_KEY = 'deca.theme'

export function readTheme(): ThemeChoice {
  const stored = localStorage.getItem(STORAGE_KEY)
  return stored === 'light' || stored === 'dark' ? stored : 'system'
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement
  if (choice === 'system') {
    root.removeAttribute('data-theme')
    localStorage.removeItem(STORAGE_KEY)
  } else {
    root.setAttribute('data-theme', choice)
    localStorage.setItem(STORAGE_KEY, choice)
  }
}
